import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import TextEditor from '@/components/TextEditor.vue';
let CharacterSheetNotes = class CharacterSheetNotes extends Vue {
};
__decorate([
    Prop(String)
], CharacterSheetNotes.prototype, "notes", void 0);
CharacterSheetNotes = __decorate([
    Component({
        components: {
            TextEditor
        }
    })
], CharacterSheetNotes);
export default CharacterSheetNotes;
